import {
    includeRule,
    excludeRule
  }
  from './rules_functions.js';

export let alt2 = ['P8']
  
export function rules_rsetc(newState, state) {
  let slist = state['options_sh'].options.flatMap(x => x['value']).filter(n => !alt2.includes(n))
  var newrule = includeRule(newState, state, 'rsetc')

    newrule = excludeRule(newState, state, [
        ['sh', slist],
        ['rsetc', ['0', 'AQ', 'LBT', 'MG', 'TZ']]], newrule)

    newrule = excludeRule(newState, state, [
        ['sh', alt2],
        ['rsetc', ['0', 'D', 'GA', 'SAP', 'EM', 'RU']]], newrule)

    return newrule
}



// WEBPACK FOOTER //
// ./src/reducers/rules_rsetc.js